export const GENERAL_INFO_SECTION_ID = 'general'
export const SCOPE_SECTION_ID = 'scope'
export const COLLABORATORS_SECTION_ID = 'collaborators'
